exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/my-dream-app/src/app/business-return-on-capital-calculator/business-return-on-capital-calculator.component.css
// module id = ../../../../../src/app/business-return-on-capital-calculator/business-return-on-capital-calculator.component.css
// module chunks = main